var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bonus-quickstart"},[_c('div',{staticClass:"bonus-quickstart__date"},[_c('span',[_vm._v("Осталось времени")]),_c('p',[_vm._v(_vm._s(_vm.timeLeft()))])]),_c('bonus-quickstart-cards',{attrs:{"end-date":_vm.bonusQuickstartEndDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }